import { render, staticRenderFns } from "./home_mian.vue?vue&type=template&id=383fb186&scoped=true"
import script from "./home_mian.vue?vue&type=script&lang=js"
export * from "./home_mian.vue?vue&type=script&lang=js"
import style0 from "./home_mian.vue?vue&type=style&index=0&id=383fb186&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383fb186",
  null
  
)

export default component.exports